import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postChatbotMessage } from "../../../../store/actions";
import { RESET_FETCH_CHATBOT_MESSAGE } from "../../../../store/actions/actionTypes";

const ActionProvider = ({ createChatBotMessage, setState, children }) => {
  const dispatch = useDispatch();
  const fetchpostChatbotMessage = useSelector(
    (state) => state.fetchpostChatbotMessage
  );
  const [chatBotResponse, setChatBotResponse] = useState(null);
  useEffect(() => {
    if (fetchpostChatbotMessage && fetchpostChatbotMessage.message) {
      setChatBotResponse(fetchpostChatbotMessage.message);
      dispatch({ type: RESET_FETCH_CHATBOT_MESSAGE });
    }
  }, [fetchpostChatbotMessage]);

  useEffect(() => {
    if (chatBotResponse) {
      try {
        const botMessage = createChatBotMessage(chatBotResponse);
        updateChatState(botMessage);
      } catch (error) {
        const errorMessage = createChatBotMessage(
          "Sorry, I couldn't process your request."
        );
        updateChatState(errorMessage);
        console.error("Error fetching ChatGPT response:", error);
      }
    }
  }, [chatBotResponse]);

  const updateChatState = (botMessage) => {
    setState((prev) => {
      const messages = [...prev.messages, botMessage];

      localStorage.setItem("chat_messages", JSON.stringify(messages));

      return {
        ...prev,
        messages,
      };
    });
  };

  const handleUserMessage = async (userMessage) => {
    dispatch(postChatbotMessage(userMessage));
  };

  return (
    <div>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          actions: {
            handleUserMessage,
          },
        })
      )}
    </div>
  );
};

export default ActionProvider;
